import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import styles from "./style.module.scss";
import ExpenseMessageForm from "@components/forms/ExpenseMessageForm";

const ValidateExpenseEInvoice = () => {

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title="Validar Gasto"
      backUrl="/user/expenses"
    >
      <ExpenseMessageForm
        formId="providerValidateForm"
        saveRedirectUrl="/user/expenses"
      ></ExpenseMessageForm>

    </PageContainer >
  );
}

export default ValidateExpenseEInvoice;
